import React from 'react';
import classNames from 'classnames';
import color from 'color';
import AntButton from 'antd/lib/button';
import 'antd/lib/button/style/index.css';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    '&:hover': {
      backgroundColor: props => color(props.color)
        .darken(0.1)
        .hex(),
      borderColor: props => color(props.color)
        .darken(0.1)
        .hex(),
    },
    '&:active, &:focus': {
      backgroundColor: props => props.color,
      borderColor: props => props.color,
    },
    '&:hover, &:active, &:focus': {
      color: 'white',
    },
    backgroundColor: props => props.color,
    borderColor: props => props.color,
    color: theme.palette.common.white,
    borderRadius: theme.radius.lg,
  },
}));

const Button = (props) => {
  const classes = useStyles(props);
  const { className, children, ...rest } = props;

  return (
    <AntButton {...rest} className={classNames(classes.root, className)}>
      {children}
    </AntButton>
  );
};
Button.defaultProps = {
  className: '',
  color: '#53B4E5',
};
Button.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};
export default Button;
